export default __webpack_public_path__ + "static/media/torso-mid-back.f1a03f85.png";